(function () {
    'use strict';

    angular.module("imApp").factory("holidaysViewService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 561,
                    parameters: parms || {}
                });
            },
            listHolidayYears: function (parms) {
                return $ihttp.post({
                    method: 563,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
